{
  "pt": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Alterar responsável"
      },
      "attributes": {
        "introduction": "Introdução",
        "responsible": "Responsável",
        "title": "Título"
      },
      "labels": {
        "ask_question": "Que tipo de pergunta é que quer fazer?",
        "editInternalTitle": "Editar o título interno?",
        "explainerNPSPart1": "O Net Promoter Score é um índice que varia entre -100 e 100 e que mede a vontade dos clientes de recomendar a sua empresa ou os seus projetos a outras pessoas.",
        "explainerOpinionScale": "Avalie a concordância dos seus clientes com uma declaração geral.",
        "fixed_choice": "Pergunta de escolha múltipla",
        "hidePreview": "Ocultar pré-visualização",
        "moreInfo": "Mais informações",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "open_ended": "Pergunta aberta",
        "opinion_scale": "Escala de opinião",
        "preview": "Pré-visualização",
        "satisfaction": "Satisfação",
        "selectSurveyType": "Selecionar inquérito",
        "showPreview": "Mostrar pré-visualização",
        "tab_summary": "Resumo",
        "tab_units": "Unidades",
        "yes_no": "Sim-Não"
      },
      "navigation": {
        "backToSurveyTypes": "Voltar aos inquéritos"
      },
      "snackbars": {
        "duplicate": "O inquérito foi criado, mas o processo de cópia a partir do modelo pode demorar alguns minutos."
      },
      "toasts": {
        "bulk_delete": "Inquérito eliminado com êxito | Inquéritos eliminados com êxito",
        "update": "Inquérito atualizado com sucesso"
      },
      "validation": {
        "nameAlreadyTaken": "O nome já foi escolhido para este projeto",
        "need_name": "Título necessário",
        "selectSurveyType": "Selecionar pelo menos 1 inquérito"
      }
    }
  }
}
